import React from 'react';
import { Compass } from 'lucide-react';
const legalLinks = [{
  label: 'Términos y Condiciones de Reembolso y Entrega',
  href: 'https://legal.bpfllc.site/terminos'
}, {
  label: 'Política de Privacidad',
  href: 'https://legal.bpfllc.site/privacidad'
}];
export function Footer() {
  return <footer className="bg-navy border-t border-steel" data-id="element-40" data-mp="36oxzd51dvozy">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8" data-id="element-41" data-mp="36ppn5toqoifo">
        <div className="flex items-center space-x-3" data-id="element-42" data-mp="38qyt7e9m7ve">
          <Compass className="w-5 h-5 text-gold" strokeWidth={1.5} data-id="element-43" data-mp="387e5ix8d5do" />
          <span className="font-display text-base tracking-tight text-cream" data-id="element-44" data-mp="3lf56iolxxllc">
            BPF LLC
          </span>
        </div>

        <nav aria-label="Enlaces legales" className="flex flex-col sm:flex-row sm:items-center gap-x-8 gap-y-3" data-id="element-45" data-mp="3qbvojhhb2r9e">
          {legalLinks.map(link => <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" className="text-[11px] font-semibold tracking-[0.15em] uppercase text-muted hover:text-gold transition-colors duration-300" data-id="element-46" data-mp="2eya1q2yx51r1">
              {link.label}
            </a>)}
        </nav>
      </div>

      <div className="border-t border-steel/40" data-id="element-47" data-mp="3gcjvsqtw40gw">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-[11px] font-semibold tracking-[0.15em] uppercase text-muted text-center lg:text-right" data-id="element-48" data-mp="3v7zuxa9bumk5">
          © 2025 BPF LLC · Todos los derechos reservados · Wyoming, EE.UU.
        </div>
      </div>
    </footer>;
}